import React, { useState, useEffect } from "react";
import { DatePicker, KeyboardDatePicker } from "@material-ui/pickers";
import { connect } from "react-redux";
import clsx from "clsx";
import { getDateValue } from "../../../../utils/helpers";

/** Seperated date picker component to handle "auto-open" feature after duplictating
 * @param {Object} props
 * @param {any} props.classes  generated styles and classlist
 * @param {bool} props.duplicate true means just duplicated project, auto-open date picker
 */

function CustomDatePicker({
  classes,
  duplicate,
  currentProject,
  setDisabled,
  currentAction,
  name,
  ...props
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (currentAction === "duplicate") {
      setTimeout(() => setOpen(true), 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderWeekDays = (
    day,
    selectedDays,
    isInCurrentMonth,
    dayComponent
  ) => {
    if (!(day.getDay() % 6) && isInCurrentMonth) {
      return <span className={classes.weekend}>{dayComponent}</span>;
    }
    return <>{dayComponent}</>;
  };

  return (
    <div>
      <KeyboardDatePicker
        disablePast
        autoOk
        format="yyyy/MM/dd"
        label="Date"
        nasme="date"
        id="edit-date"
        className={clsx(classes.inputField)}
        KeyboardButtonProps={{ disabled: true, style: { display: "none" } }}
        disabled={!duplicate && currentProject?.status === "In Progress"}
        value={props.value ? new Date(props.value) : null}
        onChange={value => {
          props.onChange(getDateValue(value));
          if (name.trim() && value) setDisabled(false);
        }}
        inputVariant="outlined"
      />
      <DatePicker
        disableToolbar
        disablePast
        autoOk
        variant="static"
        format="yyyy/MM/dd"
        error={false}
        renderDay={renderWeekDays}
        disabled={!duplicate && currentProject?.status === "In Progress"}
        value={props.value ? new Date(props.value) : new Date()}
        onChange={value => {
          console.log(value, getDateValue(value));
          props.onChange(getDateValue(value));
          if (name.trim() && value) setDisabled(false);
        }}
        onClose={() => {
          if (duplicate) {
            duplicate.current = false;
          }
          setOpen(false);
        }}
      />
    </div>
  );
}

export default CustomDatePicker;
